import s from './Assignees.module.scss';

type AssigneeType = {
  id: string;
  name: string | null;
  email: string | null;
};

type Props = {
  userId: string;
  assignees: Array<AssigneeType>
};

const Assignees: React.FC<Props> = ({ assignees, userId }) => {
  const you = assignees.find(assignee => assignee.id === userId);
  const notYou = assignees.filter(assignee => assignee.id !== userId);
  return (
    <div className='caption'>
      {you && (
        <span className={s.you}>You</span>
      )}
      {notYou.length > 0 && (
        <span>
          {you ? ', ' : ''}
          {notYou.map(assignee => assignee.name || assignee.email || assignee.id).join(', ')}
        </span>
      )}
    </div>
  );
};

export default Assignees;
